'use client';

import { useState, useEffect } from 'react';

const ColumnSelectorModal = ({
  show,
  onHide,
  availableColumns = [],
  visibleColumns = {},
  onSave,
}) => {
  const [selectedColumns, setSelectedColumns] = useState(visibleColumns);

  // Sync internal state with visibleColumns when modal opens
  useEffect(() => {
    if (show) {
      setSelectedColumns(visibleColumns);
    }
  }, [show, visibleColumns]);

  const handleColumnToggle = (columnKey) => {
    setSelectedColumns((prev) => ({
      ...prev,
      [columnKey]: !prev[columnKey],
    }));
  };

  const handleSelectAll = () => {
    const allSelected = {};
    availableColumns.forEach((col) => {
      allSelected[col.key] = true;
    });
    setSelectedColumns(allSelected);
  };

  const handleDeselectAll = () => {
    const noneSelected = {};
    availableColumns.forEach((col) => {
      noneSelected[col.key] = false;
    });
    setSelectedColumns(noneSelected);
  };

  const handleSave = () => {
    onSave(selectedColumns);
    onHide();
  };

  if (!show) return null;

  return (
    <div
      className='modal fade show d-block'
      tabIndex='-1'
      style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
    >
      <div className='modal-dialog modal-dialog-centered'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title'>
              <i className='fa fa-columns me-2'></i>
              Customize Table Columns
            </h5>
            <button
              type='button'
              className='btn-close'
              onClick={onHide}
            ></button>
          </div>
          <div className='modal-body'>
            <div className='mb-3'>
              <div className='d-flex gap-2 mb-3'>
                <button
                  className='btn btn-outline-primary btn-sm'
                  onClick={handleSelectAll}
                >
                  <i className='fa fa-check-double me-1'></i>
                  Select All
                </button>
                <button
                  className='btn btn-outline-secondary btn-sm'
                  onClick={handleDeselectAll}
                >
                  <i className='fa fa-times me-1'></i>
                  Deselect All
                </button>
              </div>
              <div className='row'>
                {availableColumns.map((column) => (
                  <div key={column.key} className='col-md-6 mb-2'>
                    <div className='form-check'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        id={column.key + '-checkbox'}
                        checked={!!selectedColumns[column.key]}
                        onChange={() => handleColumnToggle(column.key)}
                      />
                      <label
                        className='form-check-label'
                        htmlFor={column.key + '-checkbox'}
                      >
                        <i className={`fa ${column.icon} me-2 text-muted`}></i>
                        {column.label}
                      </label>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className='alert alert-info'>
              <i className='fa fa-info-circle me-2'></i>
              <small>
                Select the columns you want to display in the table. Changes
                will be saved automatically.
              </small>
            </div>
          </div>
          <div className='modal-footer'>
            <button
              type='button'
              className='btn btn-secondary'
              onClick={onHide}
            >
              <i className='fa fa-times me-1'></i>
              Cancel
            </button>
            <button
              type='button'
              className='btn btn-primary'
              onClick={handleSave}
              disabled={Object.values(selectedColumns).every((v) => !v)}
            >
              <i className='fa fa-save me-1'></i>
              Apply Changes
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ColumnSelectorModal;
